(function($){
    var $fn = $(".comp_articles");
    if($fn.length){

        $fn.on('change','select#articlesCategory', function() {
            var url = $(this).val();
            window.location.href = url;
        });

    }
})(jQuery);
